import $ from './jquery-global.js';
import datetimepickerSource from 'jquery-datetimepicker/build/jquery.datetimepicker.full.min.js?raw';

window.$ = window.jQuery = $;

const bootstrapDatetimepicker = new Function(
  'window',
  'document',
  'jQuery',
  '$',
  datetimepickerSource,
);

bootstrapDatetimepicker(window, document, $, $);

if (window.jQuery?.fn?.datetimepicker && !$.fn.datetimepicker) {
  $.fn.datetimepicker = window.jQuery.fn.datetimepicker;
}

if ($.fn.datetimepicker && window.jQuery && !window.jQuery.fn.datetimepicker) {
  window.jQuery.fn.datetimepicker = $.fn.datetimepicker;
}

if (window.jQuery?.datetimepicker && !$.datetimepicker) {
  $.datetimepicker = window.jQuery.datetimepicker;
}

if ($.datetimepicker && window.jQuery && !window.jQuery.datetimepicker) {
  window.jQuery.datetimepicker = $.datetimepicker;
}
